/**
 * Created by c0001 on 2018/6/15.
 */
import axios from 'axios';

// 设置公共请求头
const init = function () {
  let url = window.location.search.toString()
  let arr = []
  let isArr = {}
  arr = url.split('&')
  arr.forEach(l => {
    l = l.split('=')
    isArr[l[0]] = l[1]
  })
  axios.defaults.headers.common['deviceChannel'] = 'gclife_bmp_pc';
  axios.defaults.headers.common['language'] = window.localStorage.defaultLanguage;
  if (isArr.osType) {
    axios.defaults.headers.common['osType'] = isArr.osType
  } else {
    axios.defaults.headers.common['osType'] = ''
  };
  if (isArr.deviceId) {
    axios.defaults.headers.common['deviceId'] = isArr.deviceId
  } else {
    axios.defaults.headers.common['deviceId'] = ''
  };
  if (isArr.appVersion) {
    axios.defaults.headers.common['appVersion'] = isArr.appVersion
  } else {
    axios.defaults.headers.common['appVersion'] = ''
  };
  if (isArr.district) {
    axios.defaults.headers.common['district'] = isArr.district
  } else {
    axios.defaults.headers.common['district'] = ''
  };
  if (isArr.phoneModel) {
    axios.defaults.headers.common['phoneModel'] = isArr.phoneModel
  } else {
    axios.defaults.headers.common['phoneModel'] = ''
  };
  if (isArr.osVersion) {
    axios.defaults.headers.common['osVersion'] = isArr.osVersion
  } else {
    axios.defaults.headers.common['osVersion'] = ''
  };
  if (isArr.coordiate) {
    axios.defaults.headers.common['coordiate'] = isArr.coordiate
  } else {
    axios.defaults.headers.common['coordiate'] = ''
  };
  if (isArr.networkType) {
    axios.defaults.headers.common['networkType'] = isArr.networkType
  } else {
    axios.defaults.headers.common['networkType'] = ''
  };
  if (isArr.ipAddress) {
    axios.defaults.headers.common['ipAddress'] = isArr.ipAddress
  } else {
    axios.defaults.headers.common['ipAddress'] = ''
  };
}

export default {
  init
}



// WEBPACK FOOTER //
// ./src/services/request.js